export default __webpack_public_path__ + "static/media/Earlyadopters.2d711c6a.png";